export default __webpack_public_path__ + "static/media/fortune LM.94c9f012.svg";